import { useEffect, useRef } from "react";
import { Instagram, ExternalLink } from "lucide-react";

function loadEmbedScript(cb) {
  if (window.instgrm) { cb(); return; }
  let s = document.getElementById("ig-embed-js");
  if (!s) {
    s = document.createElement("script");
    s.id = "ig-embed-js";
    s.src = "https://www.instagram.com/embed.js";
    s.async = true;
    s.addEventListener("load", cb);
    document.body.appendChild(s);
  } else {
    s.addEventListener("load", cb);
    if (window.instgrm) cb();
  }
}

export default function InstagramEmbed({ url }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!url) return;
    loadEmbedScript(() => {
      try { window.instgrm?.Embeds?.process(); } catch { /* noop */ }
    });
  }, [url]);

  if (!url) return null;

  return (
    <section data-testid="post-instagram" className="mt-6 bg-white rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-navy font-bold" style={{ fontFamily: "Outfit" }}>
          <Instagram className="h-5 w-5 text-gold" /> En Instagram
        </div>
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-navy hover:underline inline-flex items-center gap-1">
          Ver en Instagram <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      <div ref={ref} className="flex justify-center">
        <blockquote
          className="instagram-media"
          data-instgrm-permalink={url}
          data-instgrm-version="14"
          style={{ background: "#FFF", border: 0, margin: 0, width: "100%", maxWidth: 540 }}
        >
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm text-navy">Ver esta publicación en Instagram</a>
        </blockquote>
      </div>
    </section>
  );
}
